var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.1364C12 5.71095 11.961 5.30186 11.8887 4.90913H6.12245V7.23004H9.41744C9.27551 7.98004 8.84416 8.61549 8.19573 9.04095V10.5464H10.1744C11.3321 9.50186 12 7.96368 12 6.1364Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12246 12C7.77552 12 9.16141 11.4628 10.1744 10.5464L8.19573 9.04095C7.64749 9.40095 6.94621 9.61363 6.12246 9.61363C4.52784 9.61363 3.17811 8.55818 2.69667 7.14H0.651209V8.69454C1.65863 10.6555 3.72913 12 6.12246 12Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69667 7.14C2.57422 6.78 2.50464 6.39549 2.50464 6.00003C2.50464 5.60458 2.57421 5.22003 2.69666 4.86003V3.30549H0.651206C0.236549 4.11549 0 5.03185 0 6.00003C0 6.96822 0.236552 7.88454 0.651209 8.69454L2.69667 7.14Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12246 2.38636C7.02134 2.38636 7.82839 2.68909 8.4629 3.28364L10.2189 1.56273C9.15864 0.594546 7.77274 0 6.12246 0C3.72913 0 1.65863 1.34458 0.651206 3.30549L2.69666 4.86003C3.17811 3.44185 4.52784 2.38636 6.12246 2.38636Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxGoogle);
export default __webpack_public_path__ + "static/media/icon_16px_google.2665b8e93150eb4d6f156e0be0745f21.svg";
export { ForwardRef as ReactComponent };